// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nearest-matches-module__emptyMatch--2QrX3{font-size:14px;line-height:1.29;font-weight:400;letter-spacing:0}.nearest-matches-module__matchWrapper--1qkzE{padding:36px 0;border:1px solid #393a40;border-radius:6px;background-color:#1a1b20;width:100%}.nearest-matches-module__emptyMatch--2QrX3{text-align:center;color:#afafaf}", ""]);
// Exports
exports.locals = {
	"emptyMatch": "nearest-matches-module__emptyMatch--2QrX3",
	"matchWrapper": "nearest-matches-module__matchWrapper--1qkzE"
};
module.exports = exports;
